import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IoGlobals } from '../ioglobals';

@Component({
    selector: 'app-price-view',
    templateUrl: './price-view.component.html',
    styleUrls: ['./price-view.component.css']
})
export class PriceViewComponent implements OnInit {

    public connect;

    public token = {
        getDetail: "mobileIntroduceGetrow"
    }

    public data: any;

    public language: string = '';

    public isLoading: boolean = true;

    constructor(
        public routerAct: ActivatedRoute,
        public IO: IoGlobals
    ) {
        this.connect = this.IO.result.subscribe((res: any) => {

            switch (res.token) {
                case this.token.getDetail:
                    if (res.status == 1) {
                        this.data = res.data;
                        this.isLoading = false;
                    }
                    break;

                default: break;
            }
        });
    }

    ngOnInit() {
        this.routerAct.params.subscribe(params => {
            let keyconfig = params.keyconfig || '';
            this.language = params.language || '';
            this.IO.send({ token: this.token.getDetail, params: { key_config: keyconfig } })
        });
    }
}
